import { makeStyles } from '@mui/styles';

export const useDismissibleIconSnackbarStyles = makeStyles(() => ({
  dismissIconButton: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
  },
}));
